import { forwardRef } from "react";

const FOLDER_PATH =
	"M20,6h-8l-1.414-1.414C10.211,4.211,9.702,4,9.172,4H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V8C22,6.9,21.1,6,20,6z";

const FolderIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement> & { size?: number }>(
	({ className, size = 24, style, ...props }, ref) => (
		<svg
			ref={ref}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			width={size}
			height={size}
			fill="currentColor"
			className={className}
			style={style}
			{...props}
		>
			<path d={FOLDER_PATH} />
		</svg>
	)
);
FolderIcon.displayName = "FolderIcon";

export { FolderIcon };
